import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  signal
} from '@angular/core';
import { AuthService } from '../../shared/auth/auth.service';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '../../shared/i18n/translate.pipe';
import { TranslationService } from '../../shared/i18n/translation.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslatePipe
  ],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
  readonly auth = inject(AuthService);
  readonly sessionReady = signal(false);
  readonly i18n = inject(TranslationService); // ou I18nService, selon ton service réel
  private readonly router = inject(Router);
  
  constructor() {
    afterNextRender(() => {
      this.sessionReady.set(true);
    });
  }

  logout(): void {
    this.auth.logout();
    this.closeMobileMenu();
  }



  // =========================================================
  // LANGUES
  // =========================================================

  public languages = [
    { code: 'FR', flag: 'fr' },
    { code: 'EN', flag: 'gb' }
  ];

  public currentLang = this.languages.find(lang => lang.code.toLowerCase() === this.i18n.language()) ?? this.languages[0];
  public isLangMenuOpen = false;


  // =========================================================
  // MENU MOBILE
  // =========================================================

  public isMobileMenuOpen = false;

  public activeDropdown: string | null = null;


  // =========================================================
  // MENU MOBILE
  // =========================================================

  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;

    // Si on ferme le menu principal,
    // on ferme également l'accordéon actif.
    if (!this.isMobileMenuOpen) {
      this.activeDropdown = null;
    }
  }


  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
    this.activeDropdown = null;
  }

  openSection(event: Event, fragment: 'histoire' | 'vision-valeurs' | 'partenaires'): void {
    // Empêche le clic du sous-menu de remonter au conteneur qui, sur mobile,
    // annule volontairement la navigation du lien parent.
    event.preventDefault();
    event.stopPropagation();
    this.closeMobileMenu();

    void this.router.navigate(['/qui-sommes-nous'], { fragment }).then(() => {
      // Une navigation vers une URL strictement identique peut être ignorée
      // par Angular. L'événement garantit malgré tout l'ouverture de la tuile.
      window.dispatchEvent(new CustomEvent('agbe:open-about-section', { detail: fragment }));
    });
  }


  // =========================================================
  // ACCORDEON
  // =========================================================

  toggleDropdown(event: Event, name: string): void {

    /*
     * Sous 900px :
     * le clic sur le menu parent ouvre/ferme l'accordéon
     * au lieu de naviguer vers sa route.
     */
    if (window.innerWidth <= 900) {
      event.preventDefault();
      event.stopPropagation();

      this.activeDropdown =
        this.activeDropdown === name
          ? null
          : name;
    }
  }


  // =========================================================
  // LANGUE
  // =========================================================

  toggleLangMenu(event: Event): void {
    event.stopPropagation();

    this.isLangMenuOpen = !this.isLangMenuOpen;
  }


  selectLang(lang: { code: string; flag: string }): void {
    this.currentLang = lang;
    this.isLangMenuOpen = false;

    this.i18n.setLanguage(lang.code.toLowerCase() === 'en' ? 'en' : 'fr');
  }


  // =========================================================
  // CLIC AILLEURS
  // =========================================================

  @HostListener('document:click')
  closeLangMenu(): void {
    this.isLangMenuOpen = false;
  }
}
